// extracted by mini-css-extract-plugin
module.exports = {"container":"Storagewordstation_container__2ZaPa","create":"Storagewordstation_create__2fH21"};